// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1013":"1594402d5904bfc1","5273":"eab77afe6a29f81b"}[chunkId] + ".js";
};